import { z } from 'zod';
import { I18nStringSchema } from './i18n';
export const CommentCategoryIconSchema = z.object({
    _id: z.string(),
    altText: I18nStringSchema,
    imageURL: z.string()
});
export const CommentCategorySchema = z.object({
    id: z.string(),
    name: I18nStringSchema,
    description: I18nStringSchema.optional(),
    imgURL: z.string()
});
//# sourceMappingURL=commentCategory.js.map